import script from "./PersonalizedEmailsChurnView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalizedEmailsChurnView.vue?vue&type=script&setup=true&lang=js"

import "./PersonalizedEmailsChurnView.vue?vue&type=style&index=0&id=a5f67c36&lang=scss"

const __exports__ = script;

export default __exports__